import { render } from "./DefaultLayout.vue?vue&type=template&id=2f9738e5"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=2f9738e5&lang=css"
import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=1&lang=css"
import "./DefaultLayout.vue?vue&type=style&index=2&id=2f9738e5&lang=css"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__